import { IPropertyEditable } from "../../../../base/domain/system/edit";
import { TextAlignKinds } from "../../../../base/domain/drawing";
import { IComboSelectBehavior, TranscribeTargetKinds } from "../../../../documaker/domain/format/objects";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { IComboObject } from "../objects";
import { IComboSelectBehaviorPropertyEditable } from "../properties";
import { AbstractSelectableObjectEditor } from "./AbstractSelectableObjectEditor";

export class ComboObjectEditor extends AbstractSelectableObjectEditor<IComboObject> implements IComboSelectBehaviorPropertyEditable {
  constructor(source: IComboObject | ComboObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._comboSelectBehavior = this.createPropertyEditor(s => s.comboSelectBehavior, (s, v) => s.comboSelectBehavior = v);
  }

  protected _comboSelectBehavior: IPropertyEditable<IComboSelectBehavior>;

  comboSelectBehavior(): IPropertyEditable<IComboSelectBehavior> {
    return this._comboSelectBehavior;
  }

  getTypeName(): string {
    return "リスト選択";
  }

  getSelectableAlignmentKinds(): TextAlignKinds[] {
    return this._specification.objects.combo.alignmentKinds;
  }

  getSelectableTranscribeTargets(): TranscribeTargetKinds[] {
    return this._specification.objects.combo.transcription.targets;
  }

  clone(): IFormatObjectEditable {
    return new ComboObjectEditor(this);
  }
}
